import { type Context, createContext } from 'react'
import type { IContainer } from 'bottlejs'
import type { DiId } from '@/common/di/di-ids'

export const AppContext: Context<IContainer<DiId> | undefined> = createContext<
  IContainer<DiId> | undefined
>(undefined)
